module.exports = __webpack_public_path__ + "media/images/uzivatele-bab9e7457a576b40a1bd9bbf3caadcdf.png";